

<form class="form-signin text-center">
  <div>
    <img class="mb-4" src="assets/images/JT_signin_Logo.gif" alt="Jobtrain Login" width="200">
  </div>
  {{ 'Login.UpdateYourPassword' | translate }}


  <input type="password" class="form-control" placeholder="Password" [(ngModel)]="changePasswordDTO.password" [ngModelOptions]="{standalone: true}" required>
  <input type="password" class="form-control" placeholder="Re-type Password" [(ngModel)]="changePasswordDTO.retypepassword" [ngModelOptions]="{standalone: true}" required>
  <button class="btn btn-lg btn-primary btn-block btn_submit " type="submit" (click)="ChangePassword()">{{ 'Login.Submit' | translate }}</button>

  <p class="text-muted">&copy; {{ 'Login.Footer' | translate }}</p>
</form>











